var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100",staticStyle:{"position":"relative"},style:(_vm.backGroundColor)},[_c('div',{ref:"designImage",staticClass:"design",style:(_vm.getDesignImageStyle)}),_c('div',{ref:"cutlineImage",staticClass:"cutLine",style:(_vm.getCutlineImageStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }